import { render } from "./Joblist.vue?vue&type=template&id=0e8d36d3&scoped=true"
import script from "./Joblist.vue?vue&type=script&lang=js"
export * from "./Joblist.vue?vue&type=script&lang=js"

import "./Joblist.vue?vue&type=style&index=0&id=0e8d36d3&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8d36d3"]])

export default __exports__